import React, {useMemo, useState} from 'react'
import {OrderCard} from '../shared'
import {AddressAction, PaymentAction} from './customer'
import {deliveryTypes, fulfillmentStatusTypes, orderTypes} from 'app/constant'
import {KTSVG} from '_metronic/helpers'
import CustomButton from './customer/CustomButton'
import {useSelector} from 'react-redux'
import {selectOrderDeliveryMethod} from '../../redux/order/orderEditSlice'
import PaymentActionV1 from '../../orderEdit/edit/components/PaymentMethod/PaymentAction'
import {CustomerEmail, CustomerName, CustomerPhone} from 'app/components/customer/CustomerInfo'
import GiftMessage from '../../components/customer/GiftMessage'
import {PAYMENT_TYPES} from 'app/constant/payment'

interface Props {
  shippingAddress: any
  billingAddress: any
  paymentMethod: any
  orderDeliveryMethod: string | any
  isShowDelete?: boolean
  onRemoveCustomer?: () => void
  email: string
  phone: number | any
  onChangeShippingAddress: (address: any) => void
  onChangeBillingAddress?: (address: any) => void
  onChangePaymentMethod?: (pm: any) => void | any
  customerId: any
  shippingPreferenceCompany?: string
  isHidePaymentMethodChange?: boolean
  firstName: string | null
  lastName: string | null
  isDraftOrder?: boolean
  isPaymentSubmitting?: boolean
  hasWineClub?: boolean
  paymentType?: string
  giftMessage?: any
  customerName?: string
  orderFulfillmentStatus?: string
  orderType?: string
}

export const EditCustomerInOrder: React.FC<Props> = ({
  orderDeliveryMethod,
  isShowDelete,
  onRemoveCustomer,
  email,
  phone,
  shippingAddress,
  billingAddress,
  onChangeBillingAddress,
  onChangeShippingAddress,
  isHidePaymentMethodChange,
  shippingPreferenceCompany,
  firstName,
  lastName,
  hasWineClub,
  paymentType,
  giftMessage,
  customerName,
  orderFulfillmentStatus,
  orderType,
  ...props
}) => {
  const [isEditMode, setIsEditMode] = useState(false)

  const editOrderDeliveryMethod = useSelector(selectOrderDeliveryMethod)
  const canShowShippingAddress = useMemo(() => {
    if (editOrderDeliveryMethod && editOrderDeliveryMethod === deliveryTypes.ship) {
      return true
    } else if (!editOrderDeliveryMethod && orderDeliveryMethod === deliveryTypes.ship) {
      return true
    }
    return false
  }, [editOrderDeliveryMethod, orderDeliveryMethod])
  const handleClick = () => {
    setIsEditMode(!isEditMode)
  }
  const getName = () => {
    if (customerName) {
      return <CustomerName customerName={customerName} />
    }
    if (firstName && lastName) {
      return <CustomerName firstName={firstName} lastName={lastName} />
    }
    return 'Guest'
  }

  const billingElement = (
    <AddressAction
      title='Billing Address'
      isEditMode={false}
      address={billingAddress}
      onChangeAddress={onChangeBillingAddress}
      {...props}
    />
  )

  const isEnablePaymentMethod = useMemo(
    () =>
      (paymentType === PAYMENT_TYPES.creditCard || orderType === orderTypes.WINE_CLUB) &&
      props.paymentMethod,
    [orderType, paymentType, props.paymentMethod]
  )

  return (
    <OrderCard
      title={
        <>
          {' '}
          {getName()}
          {hasWineClub && (
            <span className='svg-icon svg-icon-1 ms-2 '>
              <KTSVG
                path='/media/icons/corksy/crown.svg'
                className='svg-icon-warning svg-icon-2 p-0 m-0 pb-1 pt-1'
              />
            </span>
          )}
        </>
      }
      toolbar={
        <>
          {props.customerId && (
            <button
              className='btn btn-sm btn-transparent btn btn-sm btn-transparent text-primary-active fs-7'
              onClick={handleClick}
            >
              {isEditMode ? 'View' : 'Edit'}
            </button>
          )}
          {isShowDelete && onRemoveCustomer && (
            <CustomButton
              onClick={onRemoveCustomer}
              className='btn btn-icon btn-sm btn-light-danger bg-transparent'
            >
              <span className='svg-icon svg-icon-3'>
                <KTSVG path='/media/icons/duotune/general/gen034.svg' className='svg-icon-2hx' />
              </span>
            </CustomButton>
          )}
        </>
      }
    >
      {(email || phone) && (
        <div className='mb-3'>
          <div className='fs-5 fw-bolder pb-3'>Contact Information</div>
          <div className='text-primary-active mb-2'>
            <CustomerEmail email={email} />
          </div>
          <span>
            <CustomerPhone phone={phone} />
          </span>
          {orderDeliveryMethod && orderDeliveryMethod === deliveryTypes.ship && (
            <>
              <div className='fs-5 fw-bolder pb-3 mt-4'>Shipping Preference Company</div>
              <div className='text-gray-600'>
                <span className='text-gray-600'>
                  <div>{shippingPreferenceCompany ? shippingPreferenceCompany : '-'}</div>
                </span>
              </div>
            </>
          )}
        </div>
      )}
      {canShowShippingAddress && shippingAddress && (
        <AddressAction
          title='Shipping Address'
          isEditMode={isEditMode}
          address={shippingAddress}
          onChangeAddress={onChangeShippingAddress}
          {...props}
        />
      )}

      {props.isDraftOrder ? (
        <>
          {isEnablePaymentMethod && (
            <>
              <PaymentAction title='Payment Method' isEditMode={isEditMode} {...props} />
              {billingAddress && billingElement}
            </>
          )}
        </>
      ) : (
        <>
          {isEnablePaymentMethod && (
            <>
              <PaymentActionV1
                title='Payment Method'
                isEditMode={isEditMode && !isHidePaymentMethodChange}
                isEditOrder
                {...props}
              />
              {billingAddress && billingElement}
            </>
          )}
        </>
      )}
      <GiftMessage message={giftMessage} />
    </OrderCard>
  )
}

export default EditCustomerInOrder
